const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
const intro=document.querySelector('.intro');
if(intro){
  if(reduced)intro.remove();
  else{
    const counter=intro.querySelector('.intro-counter'),start=performance.now();
    function count(now){const n=Math.min(100,Math.round((now-start)/20));counter.textContent=String(n).padStart(3,'0');if(n<100)requestAnimationFrame(count)}
    requestAnimationFrame(count);
    setTimeout(()=>{intro.classList.add('done');setTimeout(()=>intro.remove(),900)},2300);
  }
}
const toggle=document.querySelector('.menu-toggle'),mobile=document.querySelector('#mobile-menu');
if(toggle&&mobile){toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));mobile.hidden=!open});mobile.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{mobile.hidden=true;toggle.setAttribute('aria-expanded','false')}))}
const reveal=document.querySelector('.word-reveal');
if(reveal){const words=reveal.textContent.trim().split(/\s+/);reveal.setAttribute('aria-label',reveal.textContent);reveal.textContent='';words.forEach(w=>{const span=document.createElement('span');span.textContent=w+' ';span.setAttribute('aria-hidden','true');reveal.append(span)});const update=()=>{const r=reveal.getBoundingClientRect(),progress=Math.max(0,Math.min(1,(innerHeight*.9-r.top)/(innerHeight*.65)));reveal.querySelectorAll('span').forEach((s,i)=>s.classList.toggle('lit',reduced||i<progress*words.length))};addEventListener('scroll',update,{passive:true});update()}
document.querySelectorAll('[data-catalog-scroll]').forEach(catalog=>{
  const stage=catalog.querySelector('.catalog-stage'),viewport=catalog.querySelector('.catalog-viewport'),track=catalog.querySelector('.catalog-track');
  const cards=[...track.querySelectorAll('.product-card')],count=catalog.querySelector('[data-catalog-count]'),bar=catalog.querySelector('[data-catalog-progress]');
  const desktop=matchMedia('(min-width: 900px) and (prefers-reduced-motion: no-preference)');
  let distance=0,current=0,target=0,frame=0;
  const clamp=(n,min,max)=>Math.max(min,Math.min(max,n));
  function measure(){
    if(!desktop.matches||cards.length<2){
      catalog.style.height='auto';track.style.transform='';cards.forEach(c=>{c.style.removeProperty('--card-prominence');c.classList.remove('is-current')});return;
    }
    distance=Math.max(0,track.scrollWidth-viewport.clientWidth);
    catalog.style.height=`${Math.ceil(stage.offsetHeight+distance)}px`;
    update(true);
  }
  function render(){
    current+=(target-current)*.14;
    if(Math.abs(target-current)<.35)current=target;
    track.style.transform=`translate3d(${-current}px,0,0)`;
    const center=viewport.getBoundingClientRect().left+viewport.clientWidth/2;
    let nearest=0,nearestDistance=Infinity;
    cards.forEach((card,i)=>{
      const r=card.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-center);
      const prominence=clamp(1-d/(r.width*1.25),0,1);
      card.style.setProperty('--card-prominence',prominence.toFixed(3));
      if(d<nearestDistance){nearestDistance=d;nearest=i}
    });
    cards.forEach((card,i)=>card.classList.toggle('is-current',i===nearest));
    count.textContent=`${String(nearest+1).padStart(2,'0')} / ${String(cards.length).padStart(2,'0')}`;
    bar.style.transform=`scaleX(${distance?clamp(current/distance,0,1):1})`;
    frame=0;
    if(Math.abs(target-current)>.35)frame=requestAnimationFrame(render);
  }
  function update(immediate=false){
    if(!desktop.matches||cards.length<2)return;
    const top=catalog.getBoundingClientRect().top-74;
    target=clamp(-top,0,distance);
    if(immediate)current=target;
    if(!frame)frame=requestAnimationFrame(render);
  }
  const observer=new ResizeObserver(measure);observer.observe(viewport);observer.observe(track);
  desktop.addEventListener('change',measure);
  addEventListener('resize',measure,{passive:true});
  addEventListener('scroll',()=>update(),{passive:true});
  viewport.addEventListener('scroll',()=>{
    if(desktop.matches)return;
    const center=viewport.getBoundingClientRect().left+viewport.clientWidth/2;
    let nearest=0,smallest=Infinity;
    cards.forEach((card,i)=>{const r=card.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-center);if(d<smallest){smallest=d;nearest=i}});
    count.textContent=`${String(nearest+1).padStart(2,'0')} / ${String(cards.length).padStart(2,'0')}`;
  },{passive:true});
  measure();
});
/* Three-scene home hero: 5 seconds per scene, with manual controls and accessibility support. */
document.querySelectorAll('[data-solid-hero-carousel]').forEach(carousel=>{
  const slides=Array.from(carousel.querySelectorAll('[data-solid-hero-slide]'));
  const dots=Array.from(carousel.querySelectorAll('[data-solid-hero-to]'));
  const count=carousel.querySelector('[data-solid-hero-count]');
  const prev=carousel.querySelector('[data-solid-hero-prev]');
  const next=carousel.querySelector('[data-solid-hero-next]');
  if(slides.length<2)return;
  let active=Math.max(0,slides.findIndex(slide=>slide.classList.contains('is-active')));
  let timer=null;
  const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setSlide(index){
    active=(index+slides.length)%slides.length;
    slides.forEach((slide,i)=>{
      const selected=i===active;
      slide.classList.toggle('is-active',selected);
      slide.setAttribute('aria-hidden',String(!selected));
    });
    dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===active)));
    if(count)count.textContent=String(active+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
  }
  function stopAuto(){if(timer!==null){window.clearInterval(timer);timer=null}}
  function startAuto(){
    stopAuto();
    if(reducedMotion||document.hidden)return;
    timer=window.setInterval(()=>setSlide(active+1),5000);
  }
  if(prev)prev.addEventListener('click',()=>{setSlide(active-1);startAuto()});
  if(next)next.addEventListener('click',()=>{setSlide(active+1);startAuto()});
  dots.forEach(dot=>dot.addEventListener('click',()=>{
    const target=Number(dot.getAttribute('data-solid-hero-to'));
    if(Number.isFinite(target)){setSlide(target);startAuto()}
  }));
  carousel.addEventListener('focusin',stopAuto);
  carousel.addEventListener('focusout',event=>{if(!carousel.contains(event.relatedTarget))startAuto()});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)stopAuto();else startAuto()});
  setSlide(active);
  startAuto();
});

/* Product variant selection and color-specific mockup filtering. */
const form=document.querySelector('.product-form');
if(form){
  const variants=JSON.parse(form.querySelector('[data-variants]').textContent);
  const id=form.querySelector('[data-variant-id]');
  const price=document.querySelector('[data-product-price]');
  const add=form.querySelector('[data-add-cart]');
  const gallery=document.querySelector('[data-product-gallery]');
  const mediaItems=gallery?Array.from(gallery.querySelectorAll('[data-product-media]')):[];
  const currency=window.Shopify?.currency?.active||'BRL';
  function normalizeText(value){
    return String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[_\s]+/g,' ').trim();
  }
  function colorKey(value){
    const v=normalizeText(value);
    if(/off[\s-]?white|cru|areia|bege/.test(v))return 'off-white';
    if(/\b(preto|preta|black)\b/.test(v))return 'preto';
    if(/\b(branco|branca|white)\b/.test(v))return 'branco';
    if(/\b(cinza|gray|grey)\b/.test(v))return 'cinza';
    if(/\b(verde|green)\b/.test(v))return 'verde';
    if(/\b(azul|blue)\b/.test(v))return 'azul';
    if(/\b(marrom|brown)\b/.test(v))return 'marrom';
    return v;
  }
  function imagePath(value){
    if(!value)return '';
    try{return new URL(value,window.location.origin).pathname}
    catch(error){return String(value).split('?')[0].split('#')[0]}
  }
  function findVariantImage(variant){
    const source=variant?.featured_image?.src||variant?.featured_image?.url||variant?.featuredImage?.url||'';
    if(!source)return null;
    const target=imagePath(source);
    return mediaItems.find(item=>imagePath(item.getAttribute('data-media-url'))===target)||null;
  }
  function updateGallery(selectedColor,variant){
    if(!gallery||!mediaItems.length)return;
    const selectedKey=colorKey(selectedColor);
    const hasColorTaggedImages=mediaItems.some(item=>Boolean(item.dataset.mediaColor));
    const variantImage=findVariantImage(variant);
    mediaItems.forEach(item=>{
      const ownColor=item.dataset.mediaColor||'';
      const role=item.dataset.mediaRole||'regular';
      let show=true;
      if(hasColorTaggedImages)show=ownColor===selectedKey && role!=='trio';
      item.hidden=!show;
      item.classList.remove('is-selected-color-hero');
    });
    const visible=mediaItems.filter(item=>!item.hidden);
    let hero=variantImage&&!variantImage.hidden?variantImage:null;
    if(!hero)hero=visible.find(item=>item.dataset.mediaColor===selectedKey&&item.dataset.mediaRole!=='trio');
    if(!hero)hero=visible.find(item=>!item.dataset.mediaColor&&item.dataset.mediaRole!=='trio');
    if(!hero)hero=visible[0];
    if(hero)hero.classList.add('is-selected-color-hero');
    visible.forEach((item,index)=>{
      const counter=item.querySelector('figcaption span:first-child');
      if(counter)counter.textContent=String(index+1).padStart(2,'0')+' / '+String(visible.length).padStart(2,'0');
    });
  }
  function updateVariant(){
    const fields=Array.from(form.querySelectorAll('.product-option'));
    const values=fields.map(field=>field.querySelector('input:checked')?.value);
    const match=variants.find(variant=>Array.isArray(variant.options)&&variant.options.every((value,index)=>value===values[index]));
    if(id)id.value=match?.id||'';
    if(add){
      add.disabled=!match?.available;
      const label=add.querySelector('span');
      if(label)label.textContent=match?(match.available?'Adicionar à sacola':'Esgotado'):'Indisponível';
    }
    if(match&&price)price.textContent=new Intl.NumberFormat('pt-BR',{style:'currency',currency}).format(match.price/100);
    const colorField=fields.find(field=>/^(cor|color|colour)$/.test(normalizeText(field.dataset.optionName||field.querySelector('legend')?.textContent)));
    const selectedColor=colorField?.querySelector('input:checked')?.value||'';
    updateGallery(selectedColor,match);
    if(match&&history.replaceState){
      const url=new URL(location.href);
      url.searchParams.set('variant',match.id);
      history.replaceState({},'',url);
    }
  }
  form.querySelectorAll('.product-option input').forEach(input=>input.addEventListener('change',updateVariant));
  const minus=form.querySelector('[data-qty-minus]');
  const plus=form.querySelector('[data-qty-plus]');
  if(minus)minus.addEventListener('click',()=>{const input=form.querySelector('[name="quantity"]');if(input)input.value=Math.max(1,(Number(input.value)||1)-1)});
  if(plus)plus.addEventListener('click',()=>{const input=form.querySelector('[name="quantity"]');if(input)input.value=Math.min(99,(Number(input.value)||1)+1)});
  updateVariant();
}
